import { ImageUploader } from "@/common/components/ImageUploader";
import TextField from "@/common/components/TextField";
import { formatCnpjCpf } from "@/common/utils/formatters";
import { CompanyData } from "../../types/company.type";
import { optionsObject as companyKinds } from "../../../../common/constants/kind.constant";

interface GeneralInformationSectionProps {
  generalInformation?: CompanyData['matrix_branch']['general_information'];
  kind?: CompanyData['kind'];
}

export const GeneralInformationSection = ({
  generalInformation,
  kind,
}: GeneralInformationSectionProps) => {
  return (
    <div className="flex flex-col gap-4">
      <p className="text-[18px] font-bold">
        Dados Gerais
      </p>

      <div className="flex gap-2">
        <div className="flex gap-2 w-full">
          <ImageUploader
            isLoading={false}
            label="Foto"
            name="profile-picture"
            currentImageUrl={generalInformation?.company_logo?.url}
            disabled
          />

          <TextField
            className="w-full mt-[14px]"
            label="CNPJ/CPF"
            defaultValue={formatCnpjCpf(generalInformation?.cnpj || '')}
            disabled
          />
        </div>

        <TextField
          className="w-full mt-[14px]"
          label="Tipo de empresa"
          defaultValue={kind ? companyKinds[kind] : ''}
          disabled
        />
      </div>

      <div className="flex gap-2">
        <TextField
          label="Nome Fantasia"
          className="w-1/2"
          maxLength={64}
          defaultValue={generalInformation?.fantasy_name}
          disabled
        />

        <TextField
          label="Nome Empresarial"
          className="w-1/2"
          maxLength={64}
          defaultValue={generalInformation?.official_name}
          disabled
        />
      </div>

      <TextField
        label="Endereço eletrônico"
        maxLength={64}
        defaultValue={generalInformation?.email}
        disabled
      />

      <div className="flex gap-2">
        <TextField
          label="IE (Inscrição Estadual)"
          defaultValue={generalInformation?.state_inscription}
          className="w-1/2"
          disabled
        />

        <TextField
          label="CNAE"
          maxLength={7}
          defaultValue={generalInformation?.primary_cnae}
          className="w-1/2"
          disabled
        />
      </div>

      <TextField
        label="Site ou Redes sociais"
        defaultValue={generalInformation?.website}
        disabled
      />
    </div>
  );
};
